import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-upsell-payment-failed',
  templateUrl: './upsell-payment-failed.component.html',
  styleUrls: ['./upsell-payment-failed.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpsellPaymentFailedComponent {
  // Controls visibility when used without *ngIf
  @Input() show = true;

  // Main message and optional details
  @Input() message?: string;
  @Input() details?: string | null;

  // Labels
  @Input() retryLabel?: string;
  @Input() closeLabel?: string;

  // Loading state for retry button
  @Input() loading = false;

  // Optional custom icon source
  @Input() iconSrc = '/assets/images/benchmarks/failed-icon.svg';
  @Input() iconAlt?: string;

  // Tracking
  @Input() trackLocation: string | null = null;
  @Input() trackUrl: string | null = null;

  @Output() retry = new EventEmitter<void>();
  // Emitted when the user explicitly chooses to update payment method via the button
  @Output() updatePaymentMethod = new EventEmitter<void>();
  // Emitted when the dialog should be simply dismissed (e.g., via X icon)
  @Output() dismiss = new EventEmitter<void>();
}
